var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormPublish" } }, [
    _c("div", { staticClass: "settings-menu" }, [
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _vm.activeItem === 0 },
          on: {
            click: function ($event) {
              return _vm.setActive(0)
            },
          },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("link")]),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _vm.activeItem === 1 },
          on: {
            click: function ($event) {
              return _vm.setActive(1)
            },
          },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("code")]),
          _vm._v(" "),
          _vm._m(1),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 2 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("group")]),
          _vm._v(" "),
          _vm._m(2),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 3 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("mail")]),
          _vm._v(" "),
          _vm._m(3),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 4 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("storage")]),
          _vm._v(" "),
          _vm._m(4),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 5 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("picture_as_pdf")]),
          _vm._v(" "),
          _vm._m(5),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 6 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("layers")]),
          _vm._v(" "),
          _vm._m(6),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.activeItem === 0
          ? _c("ShareFast", {
              attrs: { formId: _vm.formId, siteId: _vm.siteId },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.activeItem === 1
          ? _c("FormAdd", {
              attrs: { "form-id": _vm.formId, "site-id": _vm.siteId },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("HIZLI PAYLAŞ")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Direct form link and social share"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("EKLE")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Various web page embed options"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("FORMU ATA")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Assign your forms to others"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("E-POSTALAR")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Reminders and instant sharing"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("PREFILL")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Pre-populate your forms"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("PDF")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Download fillable PDF"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("PLATFORMLAR")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Third-party publish options"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }